export default "__VITE_ASSET__SF2YvCP6__"